import { Link } from "react-router-dom";
import { Globe } from "lucide-react";

const Footer = () => {
  return (
    <footer className="mt-auto border-t border-stone-800 bg-stone-950 text-stone-100">
      <div className="rc-container py-12">
        <div className="grid gap-8 lg:grid-cols-[1.1fr_auto] lg:items-end">
          <div className="space-y-3">
            <Link to="/" className="inline-flex items-center gap-2" data-testid="footer-home-link">
              <Globe className="w-5 h-5 text-amber-400" />
              <span className="font-manrope text-xl font-semibold text-stone-50">Relocation Clarity</span>
            </Link>
            <p className="max-w-md text-sm leading-6 text-stone-400">
              Independent decision support for living abroad — built to help you weigh fit, tradeoffs, and timing with more confidence.
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-start gap-x-6 gap-y-3 lg:justify-end">
          <Link 
            to="/about" 
            className="text-sm text-stone-400 transition-colors hover:text-stone-100"
            data-testid="footer-about-link"
          >
            About
          </Link>
          <Link 
            to="/insights" 
            className="text-sm text-stone-400 transition-colors hover:text-stone-100"
            data-testid="footer-insights-link"
          >
            Insights
          </Link>
          <Link 
            to="/methodology" 
            className="text-sm text-stone-400 transition-colors hover:text-stone-100"
            data-testid="footer-methodology-link"
          >
            FAQ
          </Link>
          <Link 
            to="/contact" 
            className="text-sm text-stone-400 transition-colors hover:text-stone-100"
            data-testid="footer-contact-link"
          >
            Contact
          </Link>
          <Link 
            to="/refund-policy" 
            className="text-sm text-stone-400 transition-colors hover:text-stone-100"
            data-testid="footer-refund-link"
          >
            Refund Policy
          </Link>
          <Link 
            to="/terms" 
            className="text-sm text-stone-400 transition-colors hover:text-stone-100"
            data-testid="footer-terms-link"
          >
            Terms of Service
          </Link>
          <Link 
            to="/privacy" 
            className="text-sm text-stone-400 transition-colors hover:text-stone-100"
            data-testid="footer-privacy-link"
          >
            Privacy Policy
          </Link>
          <p className="text-sm text-stone-500" data-testid="footer-copyright">
            © {new Date().getFullYear()} Relocation Clarity
          </p>
        </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
